import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {Regione} from "../../../models/Regione";
import {Provincia} from "../../../models/Provincia";
import {Citta} from "../../../models/Citta";
import {PuntoVendita, PuntoVenditaFactory} from "../../../models/PuntoVendita";
import {HasPermPipe} from "../../../pipes/has-perm.pipe";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {DataService} from "../../../services/data.service";
import {DialogService} from "../dialog/dialog.service";
import {PVenditaUtenteFactory} from "../../../models/PVenditaUtente";
import {filter} from "rxjs/operators";
import {PvenditaComponent} from "../../../pages/root/esercizio/pvendita/pvendita.component";
import {Stato} from "../../../models/Stato";
import * as _ from "lodash";
import {ServerService} from "../../../services/server.service";


@Component({
   selector: 'app-pv-form',
   templateUrl: './pv-form.component.html',
   styleUrls: ['./pv-form.component.scss']
})
export class PvFormComponent implements OnInit, OnChanges {

   @Input() pVenditaId:any;
   @Input() esercizioId:any;
   @Input() vendorSlug:any;
   @Input() isAdmin:boolean = false;
   @Input() isPopup:boolean = false;
   @Input() isNew:boolean = false;
   @Input() puntiVendita:PuntoVendita[] = []

   @Output() onSetPriority:EventEmitter<any> = new EventEmitter<any>()
   @Output() onCreatePVendita:EventEmitter<any> = new EventEmitter<any>()

   routerEvent:any;

   is_admin:boolean = false

   frmGrpPV: UntypedFormGroup = new UntypedFormGroup({});
   arrStati:Stato[] = []
   arrRegioni:Regione[] = []
   arrProvince:Provincia[] = []
   arrCitta:Citta[] = []

   p_vendita:PuntoVendita = new PuntoVendita()

   is_disabled:boolean = false

   index_pri:UntypedFormControl = new UntypedFormControl('')

   constructor(private route: ActivatedRoute,
               private router: Router,
               private pipe: HasPermPipe,
               private dataSrv: DataService,
               private fb: UntypedFormBuilder,
               private dialogSrv: DialogService,
               private pvFctr: PuntoVenditaFactory,
               private serverSrv: ServerService,
               private pvutenteFctr:PVenditaUtenteFactory) {

      this.route.data.subscribe(value => {
         this.isNew = value.isNew
         this.is_admin = value.isAdmin
      })

      this.route.paramMap.subscribe((argsMap)=>{
         this.pVenditaId = argsMap.get("pvendita_id");
         this.esercizioId = argsMap.get("esercizio_id");
      })

      this.initForm()

      console.log(this.is_admin)
      if (!this.is_admin){
         console.log("routerEvent")
         this.routerEvent = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
               if (this.pVenditaId != null){
                  console.log(this.pVenditaId)
                  this.pVenditaId = PvenditaComponent._getPVenditaId()
                  this.loadData()
               } else {
                  this.pVenditaId = PvenditaComponent._getPVenditaId()
               }
            })
      }
   }

   ngOnInit(): void {
      console.log(this.esercizioId)
      console.log("ngOnInit")
      this.fetchStati()
      this.fetchRegioni()
   }

   ngAfterViewInit(): void {
      console.log(this.puntiVendita)
      if (!this.isNew) {
         this.loadData().then(res => {
            console.log(res)
            this.setValueStato(this.p_vendita.data.indirizzo.stato ? this.p_vendita.data.indirizzo.stato.toString() : null)
            this.index_pri.patchValue(this.p_vendita.ID!.toString())
         })
      }
      if (this.isNew) this.initForm()
   }

   ngOnChanges(changes: SimpleChanges) {
      console.log(changes)
      if (changes.puntiVendita) this.loadData()

      if (this.pVenditaId && changes.pVenditaId)
         this.pVenditaId = changes.pVenditaId.currentValue
   }

   ngOnDestroy(): void {
      if (!this.is_admin) this.routerEvent.unsubscribe()
   }

   async initForm(){
      this.frmGrpPV = new UntypedFormGroup({
         index:new UntypedFormControl(''),
         index_pri:new UntypedFormControl(''),
         aperto_pubblico:new UntypedFormControl(false),
         is_virtual:new UntypedFormControl(false),
         nome:new UntypedFormControl('', Validators.required),
         prefisso:new UntypedFormControl('+39', Validators.required),
         telefono:new UntypedFormControl('', Validators.required),
         email:new UntypedFormControl('', [Validators.required, Validators.email]),
         indirizzo: new UntypedFormGroup({
            stato:new UntypedFormControl('', Validators.required),
            regione:new UntypedFormControl('', Validators.required),
            provincia:new UntypedFormControl({value:'', disabled:true}, Validators.required),
            citta:new UntypedFormControl({value:'', disabled:true}, Validators.required),
            cap:new UntypedFormControl('', Validators.required),
            indirizzo:new UntypedFormControl('', Validators.required),
            civico:new UntypedFormControl('', Validators.required)
         }),
      })
   }

   fetchRegioni(){
      Regione.getRegioni().then(
         (regioni) =>{
            this.arrRegioni = regioni
         }
      ).catch(err =>{
         console.error(err)
      })
   }

   async setValueProvince(reg: any) {
      if(!reg) return;
      await Provincia.getProvince(reg).then(
         (province) => {
            this.arrProvince = province
            this.frmGrpPV.patchValue({indirizzo: {provincia:this.p_vendita.data?.indirizzo?.provincia ? this.p_vendita.data?.indirizzo?.provincia.toString() : null}})
            this.arrCitta = []
            this.frmGrpPV.get('indirizzo')?.get('provincia')?.enable()
         })
   }

   async setValueCitta(prov) {
      if(!prov) return;
      await Citta.getCitta(prov).then(
         (citta) => {
            this.arrCitta = citta
            this.frmGrpPV.patchValue({indirizzo: {citta:this.p_vendita.data?.indirizzo?.citta ? this.p_vendita.data?.indirizzo?.citta.toString() : null}})
            this.frmGrpPV.get('indirizzo')?.get('citta')?.enable()
         })
   }

   async loadData(){
      console.log('loadData')
      if (this.pVenditaId){
         return new Promise((resolve, reject) => {
            let esercizio = this.isAdmin ? this.esercizioId : this.vendorSlug
            this.pvFctr.getPuntoVendita(esercizio, this.pVenditaId).then(res => {
               this.p_vendita = res
               console.log(this.p_vendita)
               this.frmGrpPV.patchValue(this.p_vendita.data)
               this.frmGrpPV.get('indirizzo')?.get('stato')?.patchValue(this.p_vendita.data.indirizzo.stato ? this.p_vendita.data.indirizzo.stato.toString() : null, {emitEvent:true})
               this.frmGrpPV.get('indirizzo')?.get('regione')?.patchValue(this.p_vendita.data.indirizzo.regione ? this.p_vendita.data.indirizzo.regione.toString() : null)
               this.index_pri.patchValue(this.p_vendita.ID!.toString())

               this.setValueProvince(this.p_vendita.data.indirizzo.regione).then(() => {
                  this.setValueCitta(this.p_vendita.data.indirizzo.provincia)
               })
               resolve(res)
            })
         })
      }
   }

   async clickEditPVendita() {
      return new Promise((resolve, reject) => {
         if (this.isAdmin) {
            if (this.frmGrpPV.valid){
               this.pvFctr.putPuntoVendita(this.esercizioId, this.pVenditaId, this.frmGrpPV.getRawValue()).then(res => {
                  this.dialogSrv.showToastSuccess({title:"Modifica punto vendita", msg: "Punto vendita modificato!"})
                  resolve(null)
               }).catch(err => {
                  console.error(err)
                  this.dialogSrv.showError({err: err})
                  reject(null)
               })
            }else {
               reject("Form Non Valido")
               this.frmGrpPV.markAllAsTouched()
            }
         } else {
            if (this.frmGrpPV.valid){
               this.pvutenteFctr.editPVenditaUtente(this.dataSrv.user.ID, this.dataSrv.esercizioUser.ID, this.pVenditaId, this.frmGrpPV.getRawValue())
                  .then(res => {
                     this.dialogSrv.showToastSuccess({title:"Modifica punto vendita", msg: "Punto vendita modificato"})
                     resolve(null)
                     // this.loadData()
                  }).catch(err => {
                  console.error(err)
                  this.dialogSrv.showError({title: "Impossibile modificare", err: err})
                  reject(null)
               })
            }else {
               reject("Form Non Valido")
               this.frmGrpPV.markAllAsTouched()
            }
         }
      })
   }

   async clickCreatePVendita() {
      return new Promise((resolve, reject) => {
         if (this.controlForm()){
            this.pvFctr.createPuntoVendita(this.esercizioId, this.frmGrpPV.value).then(res => {
               this.dialogSrv.showToastSuccess({title:'Nuovo punto vendita', msg:"Nuovo punto vendita creato!"})
               this.onCreatePVendita.emit()
               if (this.isAdmin)
                  this.router.navigate([`/admin/esercizi/${this.esercizioId}`])
               resolve(null)
            }).catch(err => {
               console.error(err)
               this.dialogSrv.showError({title:"Attenzione!", msg:err})
               reject(null)
            })
         }else {
            reject("Form Non Valido")
            this.frmGrpPV.markAllAsTouched()
         }
      })
   }

   controlForm(){
      console.log(this.frmGrpPV.getRawValue())
      if (!this.frmGrpPV.valid){
         this.frmGrpPV.markAllAsTouched()
         console.warn("Not valid")
         return false
      }else return true
   }


   setValueStato(triggerValue: any) {
      console.log("setValueStato")
      let stato = _.find(this.arrStati, x => x.data.id == triggerValue)
      console.log(stato)
      let regione
      let provincia
      let citta

      regione = this.frmGrpPV.get('indirizzo')?.get('regione')
      provincia = this.frmGrpPV.get('indirizzo')?.get('provincia')
      citta =  this.frmGrpPV.get('indirizzo')?.get('citta')

      if (stato?.data.nome != 'Italia' && stato){
         regione.reset()
         provincia.reset()
         citta.reset()
         regione.disable()
         provincia.disable()
         citta.disable()
         regione.clearValidators()
         provincia.clearValidators()
         citta.clearValidators()
         regione.updateValueAndValidity({onlySelf:true})
         provincia.updateValueAndValidity({onlySelf:true})
         citta.updateValueAndValidity({onlySelf:true})
      }else {
         regione.enable()
         regione.setValidators(Validators.required)
         regione.updateValueAndValidity({onlySelf:true})
         console.log(this.p_vendita)
         if (this.p_vendita.data.indirizzo.provincia) provincia.enable()
         if (this.p_vendita.data.indirizzo.citta) citta.enable()
      }

      if (!triggerValue){
         if (this.p_vendita.data.indirizzo.provincia) provincia.enable()
         if (this.p_vendita.data.indirizzo.citta) citta.enable()
      }
   }

   private fetchStati() {
      Stato.getStati().then(res => {
         this.arrStati = res
         let stato = _.find(this.arrStati, x => x.data.nome == "Italia")
         this.frmGrpPV.get('indirizzo')?.get('stato')?.patchValue(stato?.data?.id!.toString())
      }).catch(err => {
         console.error(err)
      })
   }

   setPrioritaPrelievo(pv_s) {
         this.serverSrv.put(`/api/esercizi/${this.vendorSlug}/pvendita/${this.pVenditaId}/set_index?tipo=prelievo`, {pv_s:pv_s}, null)
            .then(res => {
               this.dialogSrv.showToastSuccess({title:"Imposta indici", msg:"Indice impostato"})
               this.onSetPriority.emit()
               console.log(res)
            }).catch(err => {
            this.dialogSrv.showToastError({title:"Imposta indici", err:err})
            console.log(err)
         })
      }
}
